import type {ActionSpec, AppSpec, AppStruct} from '@cohort/shared/apps/app';
import {GetContactActionSpec} from '@cohort/shared/apps/brevo/actions/getContact';
import {GetContactAttributesActionSpec} from '@cohort/shared/apps/brevo/actions/getContactAttributes';
import {GetContactListActionSpec} from '@cohort/shared/apps/brevo/actions/getContactList';
import {GetContactListsActionSpec} from '@cohort/shared/apps/brevo/actions/getContactLists';
import type {BrevoConnectorStruct} from '@cohort/shared/apps/brevo/connector';
import {BrevoConnectorSpec} from '@cohort/shared/apps/brevo/connector';
import type {BrevoSyncStruct} from '@cohort/shared/apps/brevo/sync';
import {BrevoSyncSpec} from '@cohort/shared/apps/brevo/sync';

export const BREVO_APP_ID = 'brevo';
export const BREVO_APP_NAME = 'Brevo';

export const BrevoActionSpecs = [
  GetContactAttributesActionSpec,
  GetContactListsActionSpec,
  GetContactListActionSpec,
  GetContactActionSpec,
] as const satisfies ReadonlyArray<ActionSpec>;
type BrevoActionIds = (typeof BrevoActionSpecs)[number]['id'];

export type BrevoAppStruct = AppStruct<
  'brevo',
  BrevoConnectorStruct,
  null,
  BrevoSyncStruct,
  BrevoActionIds,
  never,
  never,
  never,
  never,
  never,
  never,
  never
>;

export const BrevoAppSpec: AppSpec<BrevoAppStruct> = {
  id: BREVO_APP_ID,
  name: BREVO_APP_NAME,
  documentationUrl: 'https://docs.getcohort.com/integrations/apps/brevo',
  merchantConnector: BrevoConnectorSpec,
  userConnector: null,
  syncSpec: BrevoSyncSpec,
  actionSpecs: [
    GetContactAttributesActionSpec,
    GetContactListsActionSpec,
    GetContactListActionSpec,
    GetContactActionSpec,
  ],
  notificationIntegrationSpecs: [],
  perkIntegrationSpecs: [],
  triggerIntegrationSpecs: [],
  userEventSpecs: [],
  userPropertySpecs: [],
  resourceSpecs: [],
  mediaSpecs: [],
};
